import React from "react";
import { useState, useEffect } from "react";

const CourseOverview = ({ course, getUrl, onSelectModule, modules, token }) => {
  const [teacherName, setTeacherName] = useState();
  useEffect(() => {
    const fetchUserName = async (token) => {
      try {
        const response = await fetch(
          `https://us-central1-extent-protocol-a.cloudfunctions.net/getUserByToken?token=${token}`
        );
        const data = await response.json();

        if (data && data.user) {
          const { name, surname, fullName } = data.user;

          const displayName =
            fullName ||
            (name && surname ? `${name} ${surname}` : name || "Без имени");

          setTeacherName(displayName);
        }
      } catch (error) {}
    };

    if (!course.teacher && token) {
      fetchUserName(token);
    } else if (course.teacher) {
      setTeacherName(course.teacher);
    }
  }, [course.teacher, token]);

  if (!course) return null;

  const structure =
    course.info_structure ||
    `${Object.keys(course.modules || {}).length} модуля с уроками и заданиями`;
  const format = course.info_format || "Гибкий график — учитесь в своём темпе";
  const advantages = course.info_advantages
    ? course.info_advantages.split("\n").filter(Boolean)
    : [
        "Доступ навсегда",
        "Сертификат после прохождения",
        "Поддержка ментора",
        "Актуальные практические задания",
      ];
  const moduleCount = Object.keys(course.modules || {}).length;

  return (
    <div className="bg-white rounded-lg shadow-md">
      <div className="flex flex-col md:flex-row gap-8 p-6">
        <div className="w-full md:w-2/5">
          <div className="rounded-lg overflow-hidden shadow-md">
            <img
              src={getUrl(course.cover_image)}
              alt={course.name}
              className="w-full h-64 object-cover"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "default-image-url.jpg";
              }}
            />
          </div>
        </div>

        <div className="w-full md:w-3/5 flex flex-col justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-800 mb-3">
              {course.name}
            </h1>
            {/* <p className="text-lg text-gray-600 mb-4">
              Преподаватель: {teacherName}
            </p> */}

            <div className="flex items-center gap-3 mb-4">
              <span className="inline-flex items-center bg-green-100 px-3 py-1 rounded-full text-green-800">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                {moduleCount} модуля
              </span>

              {/* <span className="inline-flex items-center bg-yellow-100 px-3 py-1 rounded-full text-yellow-800">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 mr-1"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  stroke="none"
                >
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                </svg>
                {mockRating} рейтинг
              </span> */}
            </div>
          </div>

          {(() => {
            const firstModuleId = Object.keys(
              modules || course.modules || {}
            )[0];
            if (!firstModuleId) return null;

            return (
              <button
                className="mt-4 bg-green-700 hover:bg-green-800 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-300 shadow-sm"
                onClick={() => onSelectModule(firstModuleId)}
              >
                Перейти к курсу
              </button>
            );
          })()}
        </div>
      </div>
      <div className="p-6 border-t border-gray-200">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">О курсе</h2>
        <div className="prose max-w-none text-gray-700">
          {course.description ? (
            <div dangerouslySetInnerHTML={{ __html: course.description }} />
          ) : (
            <p>
              Этот курс поможет вам освоить необходимые навыки и получить
              практический опыт. Программа состоит из {moduleCount} модулей,
              каждый из которых содержит теоретические материалы и практические
              задания.
            </p>
          )}
        </div>
      </div>
      <hr />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6 bg-white-50 rounded-b-lg">
        <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-100">
          <div className="flex items-center mb-3">
            <div className="p-2 bg-green-100 rounded-full mr-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-green-700"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-800">
              Структура курса
            </h3>
          </div>
          <p className="text-gray-600">{structure}</p>
        </div>

        <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-100">
          <div className="flex items-center mb-3">
            <div className="p-2 bg-green-100 rounded-full mr-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-green-700"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-800">
              Формат обучения
            </h3>
          </div>
          <p className="text-gray-600">{format}</p>
        </div>

        <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-100 md:col-span-2 lg:col-span-1">
          <div className="flex items-center mb-3">
            <div className="p-2 bg-green-100 rounded-full mr-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-green-700"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-800">
              Преимущества
            </h3>
          </div>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {advantages.map((benefit, index) => (
              <li key={index} className="flex items-center text-gray-600">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 text-green-600 mr-2 flex-shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                {benefit}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Course Description */}
    </div>
  );
};

export default CourseOverview;
